import { Box, Toolbar, Typography } from '@mui/material';
import React, { Fragment } from 'react';

import { Colors } from '../color/Colors';

export interface PageEmptyContentProperties {
  text: string;
  isFullPage?: boolean;
}

export const PageEmptyContent = ({ text, isFullPage = true }: PageEmptyContentProperties) => {
  return (
    <Fragment>
      {isFullPage && (
        <Box sx={{ px: 3 }}>
          <Toolbar />
          <Typography variant="h4">{text}</Typography>
        </Box>
      )}
      {!isFullPage && (
        <Box sx={{ px: 3, pb: 3 }}>
          <Toolbar />
          <Box
            sx={{
              px: 3,
              py: 2,
              borderRadius: 2,
              backgroundColor: Colors.bgSurface,
              border: `1px solid ${Colors.border}`,
            }}
          >
            <Typography variant="h6" sx={{ color: Colors.textSecondary }}>
              {text}
            </Typography>
          </Box>
        </Box>
      )}
    </Fragment>
  );
};
